class InvoicePreviewProduct {
    constructor() {
        this.currencyCode = null;
        this.currencySymbol = null;
        /**
         * productCode should match the list of products provided to prismic via the Backend Product Catalog
         */
        this.productCode = null;
        this.quantity = null;
        this.unitPrice = null;
        this.unitPriceUSD = null;
        this.unitPriceCAD = null;
        // baseAmount = unitPrice x quantity
        this.baseAmount = null;
        this.baseAmountUSD = null;
        this.baseAmountCAD = null;
        this.totalDiscounts = null;
        this.totalDiscountsUSD = null;
        this.totalDiscountsCAD = null;
        this.discounts = null;
        this.discountPercent = null;
        // subTotal = baseAmount - totalDiscounts
        this.subTotal = null;
        this.subTotalUSD = null;
        this.subTotalCAD = null;
    }
}
class InvoicePreviewCredit {
    constructor() {
        this.amount = null;
        this.kind = null;
        this.currencyCode = null;
        this.currencySymbol = null;
    }
}
class InvoicePreviewMultiProducts {
    constructor() {
        this.products = [];
        this.currencyCode = null;
        this.currencySymbol = null;
        this.exchangeRateToUsd = null;
        this.baseAmount = null;
        this.baseAmountUSD = null;
        this.baseAmountCAD = null;
        this.totalDiscounts = null;
        this.totalDiscountsUSD = null;
        this.totalDiscountsCAD = null;
        this.discountPercent = null;
        // subTotal = baseAmount - totalDiscounts
        this.subTotal = null;
        this.subTotalUSD = null;
        this.subTotalCAD = null;
        this.totalTaxes = null;
        this.totalTaxesUSD = null;
        this.totalTaxesCAD = null;
        this.isTaxComputationSkipped = null;
        /**
         *   The real price of what you are buying (subTotal + Taxes)
         *   Might change over time if your coupon only applies to X recurrences of your subscription
         */
        this.totalAmount = null;
        this.totalAmountUSD = null;
        this.totalAmountCAD = null;
        this.totalCredits = null;
        this.credits = null;
        /**
         *   The amount the user is going to pay at the moment of the purchase (totalAmount - totalCredits).
         */
        this.dueAmount = null;
    }
}
const keysOfInvoicePreviewMultiProducts = ["products", "currencyCode", "currencySymbol", "exchangeRateToUsd", "baseAmount", "baseAmountUSD", "baseAmountCAD", "totalDiscounts", "totalDiscountsUSD", "totalDiscountsCAD", "discountPercent", "subTotal", "subTotalUSD", "subTotalCAD", "totalTaxes", "totalTaxesUSD", "totalTaxesCAD", "isTaxComputationSkipped", "totalAmount", "totalAmountUSD", "totalAmountCAD", "totalCredits", "credits", "dueAmount"];

export { InvoicePreviewCredit, InvoicePreviewMultiProducts, InvoicePreviewProduct, keysOfInvoicePreviewMultiProducts };
